import { render, staticRenderFns } from "./SizeNavigator.vue?vue&type=template&id=c5b62642&"
import script from "./SizeNavigator.vue?vue&type=script&lang=js&"
export * from "./SizeNavigator.vue?vue&type=script&lang=js&"
import style0 from "./SizeNavigator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports